import { Card } from "primereact/card";
import type { FC, ReactNode } from "react";
import styles from "@/components/AuthCard.module.css";

interface AuthCardProps {
  beforeTitle?: ReactNode;
  children: ReactNode;
  subtitle?: string;
  title?: string;
}

const cardPt = {
  body: { className: styles.cardBody },
  content: { className: styles.cardContent },
  root: { className: styles.card },
  subTitle: { className: styles.subtitleWrap },
  title: { className: styles.titleWrap },
};

export const submitButtonPt = {
  label: { className: styles.submitButtonLabel },
  root: { className: styles.submitButton },
};

const AuthCard: FC<AuthCardProps> = ({
  beforeTitle,
  children,
  subtitle,
  title,
}) => (
  <Card
    pt={cardPt}
    subTitle={
      subtitle ? <p className={styles.subtitle}>{subtitle}</p> : undefined
    }
    title={
      beforeTitle || title ? (
        <>
          {beforeTitle}
          {title && <h2 className={styles.title}>{title}</h2>}
        </>
      ) : undefined
    }
  >
    {children}
  </Card>
);

export default AuthCard;
